export default __webpack_public_path__ + "static/media/zhijie.1f7a6828.svg";